<template>
  <app-layout>
    <section
      class="shadow-sm bg-white rounded-lg pt-4 pb-2 px-6 w-full md:w-1/2"
    >
      <text-input
          v-model="form.name"
          label="Name"
          class="mb-5"
          :error="errors['name'] ? errors['name'][0] : ''"
      />

      <textarea-input
          v-model="form.note"
          label="Note"
          class="mb-5"
          :error="errors['note'] ? errors['note'][0] : ''"
      />

      <select-input
          v-model="selectedType"
          label="Device type"
          :options="deviceTypes"
          class="mb-5"
      />

      <select-input
          v-model="selectedPlanType"
          label="Plan type"
          :options="planTypes"
          class="mb-5"
      />

      <number-input
          v-model="form.extra_charge"
          label="Extra charge $"
          class="mb-5"
          :error="errors['extra_charge'] ? errors['extra_charge'][0] : ''"
      />

      <button-input
          text="Update"
          :loading="loading"
          :disabled="loading"
          @click="submit"
      />
    </section>
  </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";

export default {
  name: "DevicesEdit",

  components: {AppLayout},

  data() {
    return {
      model: 'devices',
      pageTitle: 'Edit Device',
      deviceTypes: [
        {id: 1, name: '4G Device'},
        {id: 2, name: '5G Device'},
      ],
      planTypes: [
        {id: 'day', name: 'Day plan'},
        {id: 'month', name: 'Month plan'},
      ],
      selectedType: {},
      selectedPlanType: {},
      form: {
        name: "",
        note: "",
        type: 1,
        extra_charge: 0,
        image: null,
        plan_type: 'day',
      },
      errors: {},
      loading: false,
    };
  },

  created() {
    this.loadData();

    this.$store.dispatch('setNavTitle', this.pageTitle);
  },

  methods: {
    loadData() {
      this.$store.dispatch("devices/getEditData", this.$route.params.id)
          .then(res => {
              let device = res.data;

              this.form = {
                  name: device.name,
                  note: device.note,
                  extra_charge: device.extra_charge,
                  type: device.type,
                  plan_type: device.plan_type,
              }

              this.selectedType = this.deviceTypes.find(type => {return type.id === parseInt(device.type)});
              this.selectedPlanType = this.planTypes.find(type => {return type.id === device.plan_type});
          })
          .catch(error => {
              this.$toast.warning(error.data.message);
          });
    },

    submit() {
      this.loading = true;

      let formData = this.form;
      formData.id = this.$route.params.id;
      formData.type = this.selectedType.id;
      formData.plan_type = this.selectedPlanType.id;

      this.$store.dispatch(`devices/update`, formData)
          .then(() => {
              this.$router.push(`/devices`);
              this.loading = false;
          })
          .catch(error => {
              this.$toast.warning(error.data.message);
              this.errors = error.data.errors;
              this.loading = false;
          });
    }
  }
};
</script>
